<script setup lang="ts">
import { cx } from '../ui'

defineProps<{
  head?: unknown
  class?: string
}>()
</script>

<template>
  <div class="overflow-x-auto">
    <table :class="cx('w-full table-fixed border-collapse text-[13px]', $props.class)">
      <thead v-if="$slots.head" class="border-b border-line bg-raised/70">

        <slot name="head" />
      </thead>
      <tbody class="divide-y divide-line">
        <slot />
      </tbody>
    </table>
  </div>
</template>
